import * as C from "../Vars/charts";
import Papa from "papaparse";
import ChartDisplayHandler from "./ChartDisplayHandler";
import ChartTableHandler from "./ChartTableHandler";

class ChartDataHanlder {
  constructor(chartInput) {
    const filePath = chartInput.value;
    const data = chartInput.getAttribute("data-csvArray-" + C.lang);
    C.currentChartyAxisTitle = chartInput.getAttribute("data-yAxis-title");
    const legendSize = chartInput.getAttribute("data-legend-small");
    if(legendSize == 'true'){
      C.chartArea.classList.add('legend-small');
    } else {
      C.chartArea.classList.remove('legend-small');
    }
    C.currentChartName = chartInput.nextElementSibling.innerHTML;
    const csvConfigColumnArr = data.split(",");
    this.processedData;
    this.configcolumnArr;
    C.chartTitle.innerHTML = C.currentChartName;

    Papa.parse(filePath, {
      download: true,
      complete: (results) => {
        this.cleanData(results, csvConfigColumnArr);
        this.processData();
        C.chartRenderCounter = 0;
        new ChartDisplayHandler();
        new ChartTableHandler();
      },
    });
  }

  /**
   * Cleans out unused Data from File (other langs, empty line at end)
   */
  cleanData(results, csvConfigColumnArr) {
    const rows = [];
    // remove empty data excel always adds...
    results.data.forEach((col) => {
      if (col[0].length > 0) {
        rows.push(col);
      }
    });

    const colsToIgnore = [];
    // create new array of Indexes with ignore columns
    for (let i = 0; i < csvConfigColumnArr.length; i++) {
      if (csvConfigColumnArr[i] == "ignore") {
        colsToIgnore.push(i);
      }
    }

    // after array of Cols to ignore is created, remove the ignore elements from array
    // (for categories, indexes are messed up if this is done in the same loop)
    for (let i = 0; i < csvConfigColumnArr.length; i++) {
      if (csvConfigColumnArr[i] == "ignore") {
        csvConfigColumnArr.splice(i, 1);
        i--;
      }
    }

    // remove all columns from the ignore columns
    rows.forEach((row, i) => {
      for (var i = colsToIgnore.length - 1; i >= 0; i--) {
        row.splice(colsToIgnore[i], 1);
      }
    });
    C.csvChartData = rows;
    C.csvChartCSVConfigArray = csvConfigColumnArr;
  }

  processData() {
    const rows = C.csvChartData;
    const csvConfigColumnArr = C.csvChartCSVConfigArray;

    const transposed = rows[0].map((_, colIndex) =>
      rows.map((row) => row[colIndex])
    );

    const swappedSeriesData = [];
    const swappedCats = [];

    const seriesData = [];
    const cats = [];

    rows.forEach((row, i) => {
      if (i == 0) {
        // table headers
        // if col is not part of config, it is data, thus data titles are created here (categories)
        row.forEach((col, i) => {
          if (i >= csvConfigColumnArr.length) {
            cats.push(col);
          }
        });
      } else {
        const rowObj = {};
        const rowData = [];
        row.forEach((col, i) => {
          // make sure it is not string true false, but proper
          if (col == "true") {
            col = true;
          }
          if (col == "false") {
            col = false;
          }
          // if col is a float, parse it
          let val = parseFloat(col);
          if (!isNaN(val)) {
            col = parseFloat(col);
          }
          // if element is defined as being config, add as config to Object
          csvConfigColumnArr.forEach((item, index) => {
            if (i == index) {
              rowObj[item] = col;
            }
          });
          // if element is part of data, push to data
          if (i >= csvConfigColumnArr.length) {
            rowData.push(col);
          }
        });
        rowObj.data = rowData;
        seriesData.push(rowObj);
      }
    });

    // grab Index of Name column for swapped legends
    let nameIndex = null;
    for (let i = 0; i < csvConfigColumnArr.length; i++) {
      if (csvConfigColumnArr[i] == "name") {
        nameIndex = i;
      }
    }

    let visibleIndex = null;
    for (let i = 0; i < csvConfigColumnArr.length; i++) {
      if (csvConfigColumnArr[i] == "visible") {
        visibleIndex = i;
      }
    }

    const swappedInactiveCats = [];
    transposed[visibleIndex].forEach((col, i) => {
      if(col == 'false'){
        swappedInactiveCats.push(i);
      }
    });

    // build swapped Data Array, this does not allow
    // combination chart of line and column, it's all visible and set to column
    transposed.forEach((row, i) => {
      if (i == nameIndex) {
        row.forEach((col, i) => {
          if (i > 0) {
            swappedCats.push(col);
          }
        });
      }
      if (i >= csvConfigColumnArr.length) {
        const rowObj = {};
        const rowData = [];
        row.forEach((col, i) => {
          if (i == 0) {
            rowObj.name = col;
          }
          if (i > 0) {
            // if col is a float, parse it
            let val = parseFloat(col);
            if (!isNaN(val)) {
              col = parseFloat(col);
            }
            rowData.push(col);
          }
        });
        // rowObj.type = "column";
        // rowObj.visible = true;
        rowObj.data = rowData;
        swappedSeriesData.push(rowObj);
      }
    });

    C.csvChartSeriesArray = seriesData;
    C.csvChartCatArray = cats;
    C.csvSwappedChartSeriesArray = swappedSeriesData;
    C.csvSwappedChartCatArray = swappedCats;
    C.csvSwappedInactiveCats = swappedInactiveCats;
  }
}

export default ChartDataHanlder;
